/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamConstancyWorkResultDto } from './BeamConstancyWorkResultDto';
import {
    BeamConstancyWorkResultDtoFromJSON,
    BeamConstancyWorkResultDtoFromJSONTyped,
    BeamConstancyWorkResultDtoToJSON,
} from './BeamConstancyWorkResultDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { EvaluationParameterDto } from './EvaluationParameterDto';
import {
    EvaluationParameterDtoFromJSON,
    EvaluationParameterDtoFromJSONTyped,
    EvaluationParameterDtoToJSON,
} from './EvaluationParameterDto';
import type { WorkState } from './WorkState';
import {
    WorkStateFromJSON,
    WorkStateFromJSONTyped,
    WorkStateToJSON,
} from './WorkState';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { ParameterCombinationDto } from './ParameterCombinationDto';
import {
    ParameterCombinationDtoFromJSON,
    ParameterCombinationDtoFromJSONTyped,
    ParameterCombinationDtoToJSON,
} from './ParameterCombinationDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface BeamConstancyWorkStepDto
 */
export interface BeamConstancyWorkStepDto {
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkStepDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkStepDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ParameterCombinationDto}
     * @memberof BeamConstancyWorkStepDto
     */
    combination?: ParameterCombinationDto;
    /**
     * 
     * @type {Array<EvaluationParameterDto>}
     * @memberof BeamConstancyWorkStepDto
     */
    evaluations?: Array<EvaluationParameterDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BeamConstancyWorkStepDto
     */
    isExecutable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    workStepPreviewId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BeamConstancyWorkStepDto
     */
    evaluationIds?: Array<string> | null;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof BeamConstancyWorkStepDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {WorkState}
     * @memberof BeamConstancyWorkStepDto
     */
    workState?: WorkState;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof BeamConstancyWorkStepDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    commentEntityCompositeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkStepDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkStepDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof BeamConstancyWorkStepDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof BeamConstancyWorkStepDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {Array<BeamConstancyWorkResultDto>}
     * @memberof BeamConstancyWorkStepDto
     */
    results?: Array<BeamConstancyWorkResultDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    $type?: BeamConstancyWorkStepDtoTypeEnum;
}


/**
 * @export
 */
export const BeamConstancyWorkStepDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoBeamConstancyWorkStepDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkStepDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamConstancyWorkStepDtoTypeEnum = typeof BeamConstancyWorkStepDtoTypeEnum[keyof typeof BeamConstancyWorkStepDtoTypeEnum];



/**
 * Check if a given object implements the BeamConstancyWorkStepDto interface.
 */
export function instanceOfBeamConstancyWorkStepDto(value?: unknown): value is BeamConstancyWorkStepDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamConstancyWorkStepDtoTypeEnum)[0];
}

export function BeamConstancyWorkStepDtoFromJSON(json: any): BeamConstancyWorkStepDto {
    return BeamConstancyWorkStepDtoFromJSONTyped(json, false);
}

export function BeamConstancyWorkStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamConstancyWorkStepDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'combination': json['combination'] == null ? undefined : ParameterCombinationDtoFromJSON(json['combination']),
        'evaluations': json['evaluations'] == null ? undefined : ((json['evaluations'] as Array<any>).map(EvaluationParameterDtoFromJSON)),
        'isExecutable': json['isExecutable'] == null ? undefined : json['isExecutable'],
        'workStepPreviewId': json['workStepPreviewId'] == null ? undefined : json['workStepPreviewId'],
        'evaluationIds': json['evaluationIds'] == null ? undefined : json['evaluationIds'],
        'taskType': json['taskType'] == null ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'workState': json['workState'] == null ? undefined : WorkStateFromJSON(json['workState']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'commentEntityCompositeId': json['commentEntityCompositeId'] == null ? undefined : json['commentEntityCompositeId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(BeamConstancyWorkResultDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamConstancyWorkStepDtoToJSON(value?: Omit<BeamConstancyWorkStepDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'combination': ParameterCombinationDtoToJSON(value['combination']),
        'evaluations': value['evaluations'] == null ? undefined : ((value['evaluations'] as Array<any>).map(EvaluationParameterDtoToJSON)),
        'isExecutable': value['isExecutable'],
        'workStepPreviewId': value['workStepPreviewId'],
        'evaluationIds': value['evaluationIds'],
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        'workState': WorkStateToJSON(value['workState']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'commentEntityCompositeId': value['commentEntityCompositeId'],
        'commentCount': value['commentCount'],
        'lastComment': value['lastComment'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(BeamConstancyWorkResultDtoToJSON)),
        '$type': value['$type'],
    });
}

